import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './component/auth/login/login.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { MatchPasswordDirective } from './directives/match-password.directive';
import { NgxPaginationModule } from 'ngx-pagination';
import { CarouselModule } from 'ngx-owl-carousel-o';


import { SidebarComponent } from './component/child-component/sidebar/sidebar.component';
import { HeaderComponent } from './component/child-component/header/header.component';
import { ChangePasswordComponent } from './component/change-password/change-password.component';
import { LoaderComponent } from './component/child-component/loader/loader.component';

//validations
import { DecimalDirective } from './directives/decimal/decimal.directive';
import { TrimDirective } from './directives/trim/trim.directive';

import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CountdownPipe } from './directives/countdown/countdown.pipe';
import { PasswordStrengthDirective } from './password-strength.directive';
import { DatePipe } from '@angular/common';
import { RegisterBulkUploadComponent } from './component/register-bulk-upload/register-bulk-upload.component';

//I keep the new line
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SidebarComponent,
    HeaderComponent,
    ChangePasswordComponent,
    LoaderComponent,
    MatchPasswordDirective,
    DecimalDirective,
    TrimDirective,
    CountdownPipe,
    PasswordStrengthDirective,
    RegisterBulkUploadComponent
  ],
  imports: [
// ProductDetailsComponent,

    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxPaginationModule,
    CarouselModule,
    NgMultiSelectDropDownModule.forRoot(),
    ToastrModule.forRoot({
      closeButton: true,
      positionClass: 'toast-top-right',
      timeOut: 5000, // 5 seconds,
      autoDismiss:true,
      progressBar: true,
    }),
    NgxSliderModule,
    NgbModule
  ],
  providers: [
    DatePipe,
    provideClientHydration(),
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA],
})


export class AppModule {
}
